module.exports = __webpack_public_path__ + "static/media/dromarkivet_model.d2ce2ac0.png";